import React from "react";
import Sectiontitle from "../section-title";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "./style.css";

const Portfolios = [
  {
    Pimg: "https://lh3.googleusercontent.com/d/1ZWaCpsdpBads-J1h6E6IcWfUBEt24dbd",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/10IHj_b2A39dm3pqvXewP_xkBK1f_ZGoq",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/1p4GLu7q4dmIkrg99q4PVFhHL0HcgJ9QO",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/1p1QqtOf6H1QIUkLYLGnhXCvpo3g8Ehwz",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/1McFnjw1-yLjZClrFGANHrKmUymLZuhRu",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/1nvVg6eYr6mshwRzDZUK3qMTgJAUSpWsz",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/1XBTNGiiojvrbMoGO4vHIAHNDMlx41lq7",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/1q9rbBeBfLDxh6CUbYAL_X1ogcjObissS",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/1GZxrmE05nUlvReoCX2Que69QF9s4PeKT",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/10G-Ck5GE86uo9EyG9gvKcKNPfrTeNB3p",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/1os7G1XPEv5PHsxhG-p53y6aYvZiuZIDE",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/1N4awOenmc9usOjIyKJA3G4wmbFlKFKqp",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/1Aih3t-0zhY8k0NUvhNZXDOw7GWFaBikB",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/1ujqIsN5XoRDWp8N3fFg9GqELQyxUbQcv",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/1xtiiof4u9_7YYtFhGpDcWfktqoFjn7zr",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/1XcVF23eFVyvW8asjgiKjNYaJOrg8d55S",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/1ZhauKyT-vAY1q-3WgLbbgsblvv3Y0FQ8",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/16VM30OxNhVyf5r1OmA99bvtEyDF5wSNj",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/1dqG01ClGNOUda_PidXojnX3X8iQuENbS",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/1R2YVGbhzWo1Zxyonfld1r1Kot0uhF4v5",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/197LpY-JsU0PytFYu1vXiKLD_fEt5qQaW",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/1KqSePPT8RRj7fQvL--BIHnXyfrZJBAM-",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/1fmPxolmAyGBo8npHjkhVxEh0unO_OEtR",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/1Ea0AKXuhywHVW5Z8HLi3FAn4I81vUWRw",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/1lO2q0lx3UqWxgxuIgPZw9zrJhOEQIkWE",
  },
  {
    Pimg: "https://lh3.googleusercontent.com/d/1o_p1P4Ba_CtC42zKQ7hQ8PSRVrnAA9gF",
  },
];
const Gallery = (props) => {
  const [open, setOpen] = React.useState(false);
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const [columns, setColumns] = React.useState(4);
  const [visibleCount, setVisibleCount] = React.useState(6);
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const updateColumns = () => {
      const width = window.innerWidth;
      if (width >= 1200) {
        setColumns(4);
        setIsMobile(false);
      } else if (width >= 900) {
        setColumns(3);
        setIsMobile(false);
      } else if (width >= 750) {
        setColumns(3);
        setIsMobile(false);
      } else {
        setColumns(1);
        setIsMobile(true);
      }
    };

    updateColumns();
    window.addEventListener('resize', updateColumns);
    return () => window.removeEventListener('resize', updateColumns);
  }, []);

  const handleLoadMore = () => {
    setVisibleCount(prev => Math.min(prev + 6, Portfolios.length));
  };

  const displayedPortfolios = isMobile ? Portfolios.slice(0, visibleCount) : Portfolios;

  const columnArrays = React.useMemo(() => {
    const arrays = Array.from({ length: columns }, () => []);
    
    if (isMobile) {
      // Mobile: mỗi hình một hàng, 1 cột
      displayedPortfolios.forEach((image, i) => {
        const originalIndex = Portfolios.findIndex(p => p.Pimg === image.Pimg);
        arrays[0].push({ ...image, originalIndex });
      });
    } else if (columns === 4) {
      // Desktop: phân bổ đều vào 4 cột (thứ tự cân bằng chiều cao)
      const colOrder = [0, 1, 2, 3];
      Portfolios.forEach((image, i) => {
        const imageWithIndex = { ...image, originalIndex: i };
        arrays[colOrder[i % columns]].push(imageWithIndex);
      });
    } else {
      // Với số cột khác, phân bổ bình thường
      Portfolios.forEach((image, i) => {
        arrays[i % columns].push({ ...image, originalIndex: i });
      });
    }
    
    return arrays;
  }, [columns, isMobile, displayedPortfolios]);

  return (
    <div id="gallery" className="Gallery-section section-padding pb-70">
      <Sectiontitle section={"Khoảnh khắc"} />
      <div className="container">
        <div className="gallery-horizontal-wrapper">
          <div className="gallery-masonry-container">
            {columnArrays.map((column, colIndex) => (
              <div key={colIndex} className="gallery-masonry-column">
                {column.map((image, imgIndex) => (
                <div
                  className="gallery-img"
                    onClick={() => {
                      setCurrentIndex(image.originalIndex);
                      setOpen(true);
                    }}
                    key={colIndex * 100 + imgIndex}
                >
                  <img
                    src={image.Pimg.includes("googleusercontent.com") ? `${image.Pimg}=w600` : image.Pimg}
                    alt=""
                    loading="lazy"
                    className="img img-responsive"
                  />
                </div>
              ))}
              </div>
            ))}
          </div>
        </div>
        {isMobile && visibleCount < Portfolios.length && (
          <div className="gallery-load-more">
            <button className="load-more-btn" onClick={handleLoadMore}>
              Xem thêm
            </button>
          </div>
        )}
      </div>
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        index={currentIndex}
        slides={Portfolios.map((item) => ({ src: item.Pimg }))}
      />
    </div>
  );
};

export default Gallery;
